module.exports = __webpack_public_path__ + "img/途牛_03.3ad2c859.jpg";